import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ValidateformComponent } from '../../common/validateform/validateform.component';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/UserService';
import { AccountService } from '../../services/AccountService';
import { Message } from 'primeng/api/message';
import { AlertService } from '../../services/AlertService';

@Component({
  selector: 'app-user-password-reset',
  templateUrl: './user-password-reset.component.html',
    styleUrls: ['./user-password-reset.component.scss']    
})
export class UserPasswordResetComponent implements OnInit {
    @ViewChild('f', { static: true }) resetPasswordF: NgForm;
    @ViewChild('resetPasswordForm', { static: true }) private formValidator: ValidateformComponent;

    @ViewChild('f1', { static: true }) requestNewLinkdF: NgForm;
    @ViewChild('requestNewLinkdForm', { static: true }) private formValidator1: ValidateformComponent;

    password: string = '';
    passwordConfirm: string = '';
    parms: any;   
    passwordViewModel: any;
    requestNewLink: boolean = false;
    email: any;
    showRequestNewLinkDialog: boolean = false;
    currentURL: any;
    title: any;


    constructor(private activatedRoute: ActivatedRoute,
                private userService: UserService,
                private router: Router,
        private accountService: AccountService,
        private alertService: AlertService) {
        this.currentURL = window.location.href; 
    }

    ngOnInit(): void {
        this.accountService.RemoveLoggedInUser();
        this.parms = this.activatedRoute.snapshot.data['parms'];
        this.passwordViewModel = { userId: this.parms.userid, token: this.parms.token, email: this.parms.email };

        if (this.currentURL.includes('forgotpassword'))
            this.title = 'Password Assistance';
        else if (this.currentURL.includes('welcome'))
            this.title = 'Welcome To NAI';

    }

    resetPassword() {
        if (this.password.length < 8 || !this.validatePassword(this.password)) {
            this.resetPasswordF.form.controls['Password'].setErrors({ 'passowrdInvalid': true });
        }
        else if (this.passwordConfirm != this.password) {
            this.resetPasswordF.form.controls['Password'].setErrors({ 'passwordNoMatch': true });
        }

        if (this.formValidator.validateForm()) {
            this.passwordViewModel.password = this.password;
            this.userService.resetPassword(this.passwordViewModel).subscribe(result => {
                if (result == null || !result.Succeeded) {
                    if (result.Errors != null && result.Errors.length> 0) {
                        var err = result.Errors.find(e => e.includes('Token Expired'));
                        if (err != undefined) {
                            if (this.currentURL.includes('forgotpassword')) {                                
                                this.router.navigate(['forgotpassword']);
                                //this.alertService.SetMessage('error', 'Your reset password link is expired. Please request a new link.');
                                this.requestNewLinkWithEmail();
                            }
                            else if (this.currentURL.includes('welcome')) {                                
                                this.requestNewLink = true;
                                //this.alertService.SetMessage('error', 'Your reset password link is expired. Please request a new link.');
                                this.requestNewLinkWithEmail();
                            }                                                          
                        }
                        else {
                            this.alertService.SetMessage('error', 'There is an error while reseting password');
                        }
                    }
                }
                else {
                    this.router.navigate(['login']);
                    this.alertService.SetMessage('success','Your password successfully setup. Please login to continue setting up your profile');                    
                }              
            },
            error => {                 
                this.alertService.SetMessage('error', 'There is an error while reset password');
            });
        }
    }

    showRequestNewLink() {
        this.showRequestNewLinkDialog = true;
    }

    sendRequestNewLink() {
        if (this.formValidator1.validateForm()) {
            this.passwordViewModel.Email = this.email;
            this.requestNewLinkWithEmail();
        }
    }

    requestNewLinkWithEmail() {
        this.userService.requestNewToken(this.passwordViewModel).subscribe(result => {
            if (result) {
                this.alertService.SetMessage('success', 'Successfully request new link. You will receive a new link soon.');
                this.showRequestNewLinkDialog = false;
            }
        },
        error => {
            this.alertService.SetMessage('error', 'There is an error while request new link. Please make sure you have a correct email.');
        });
    }

    validatePassword(pass) {
        let hasNumber = /\d/.test(pass);
        let hasUpper = /[A-Z]/.test(pass);
        let hasLower = /[a-z]/.test(pass);
        let hasSpecialChar = /[$&+,:;=?@#|'<>.^*()%!-]/.test(pass);
        var result = hasNumber && hasUpper && hasLower && hasSpecialChar;
        
        return result;
    }

}
